module.exports = __webpack_public_path__ + "static/media/Board of Studies_2023-24.52ea46f8.pdf";